export default "/images/vendor/flag-icon-css/flags/1x1/sa.svg?dbdc272cb217fd407ff810ae4b6e2762";